import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式
import storage from '@/utils/storage'
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requireAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.token) {
      next({
        path: '/index',
        query: {
          redirect: to.fullPath
        }
      })
      store.commit('SET_LOGIN_POP_STATE', true)
      store.commit('SET_REDIRECT', to.fullPath)
    } else {
      if (to.path === '/vip/bind') {
        if (storage.get('user').is_check_email === '1') {
          router.replace({
            path: '/404'
          })
          return
        }
      }
      if (to.path === '/vip/unbind') {
        if (storage.get('user').is_check_email === '0') {
          router.replace({
            path: '/404'
          })
          return
        }
      }
      NProgress.start()
      next();
    }
  } else {
    NProgress.start()
    next(); // 确保一定要调用 next()
  }
});

router.afterEach((to, from) => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/login.js